<div class="templateBody">
  <form [formGroup]="userForm" novalidate>

    <!-- email -->
    <div class="form-group" [ngClass]="isValid('email')">
      <label>E-mail</label>
      <input type="email" class="form-control reduce-width" formControlName="email">
      <div *ngIf="hasError('email')">
        <p class="err-msg" [innerText]="getErrorMsg('email')"></p>
      </div>
      <small>A valid e-mail address. All e-mails from the system will be sent to this address. The e-mail address is
        not made public and will only be used if you wish to receive a new password or wish to receive certain news or
        notifications by e-mail.</small>
    </div>

    <!-- password -->
    <div class="form-group" [ngClass]="isValid('password')">
      <label class="inc-top">Password</label>
      <input type="password" class="form-control reduce-width" formControlName="password">
      <div *ngIf="hasError('password')">
        <p class="err-msg" [innerText]="getErrorMsg('password')"></p>
      </div>
    </div>

    <!-- confirm password -->
    <div class="form-group" [ngClass]="isValid('confirmPassword')">
      <label>Confirm password</label>
      <input type="password" class="form-control reduce-width" formControlName="confirmPassword">
      <div *ngIf="hasError('confirmPassword')">
        <p class="err-msg" [innerText]="getErrorMsg('confirmPassword')"></p>
      </div>
      <div class="panel panel-default">
        <div class="panel-body">To make your password stronger:</div>
        <ul>
          <li>Make it at least 6 characters</li>
          <li>Add uppercase letters</li>
          <li>Add numbers</li>
          <li>Add punctuation</li>
        </ul>
      </div>
      <small style="margin-left:20px;">Provide a password for the new account in both fields.</small>
    </div>

    <!-- roles -->
    <div class="form-group">
      <label class="inc-top">Roles</label>
      <div class="checkbox" *ngFor="let role of availableRoles;  let i = index" [ngClass]="(i==0) && 'reduce-top'"
        formArrayName="roles">
        <label>
          <input type="checkbox" name="roles" [formControlName]="i">
          {{role.str}}
        </label>
      </div>
      <div *ngIf="hasError('roles')">
        <p class="err-msg" [innerText]="getErrorMsg('roles')"></p>
      </div>
    </div>

    <!-- service center -->
    <div class="form-group">
      <label class="inc-top">Service Center</label>
      <div class="radio reduce-top">
        <label>
          <input type="radio" name="serviceCenterCode" value="E" formControlName="serviceCenterCode">Eastern
        </label>
      </div>
      <div class="radio">
        <label>
          <input type="radio" name="serviceCenterCode" value="C" formControlName="serviceCenterCode">Central
        </label>
      </div>
      <div class="radio">
        <label>
          <input type="radio" name="serviceCenterCode" value="W" formControlName="serviceCenterCode">Western
        </label>
      </div>
      <div class="radio">
        <label>
          <input type="radio" name="serviceCenterCode" value="A" formControlName="serviceCenterCode">Flight Standards Service (AFS)
        </label>
      </div>   
      <div class="radio">
        <label>
          <input type="radio" name="serviceCenterCode" value="X" formControlName="serviceCenterCode">External
        </label>
      </div>           
    </div>

    <!-- airport -->
    <div class="form-group" *ngIf="canSelectAirport">
      <label class="block">Airport</label>
      <div>
        <p-select #aptCombo [options]="airports" optionLabel="aptCode" [editable]="true" [style]="{'width':'100px'}"
          placeholder="Search" formControlName="selectedAirport" [(ngModel)]="selectedAirportReset"
          styleClass="primeng-custom" (onChange)="updateAirportList($event,aptCombo)">
        </p-select>
      </div>
    </div>

    <!-- first name -->
    <div class="form-group" [ngClass]="isValid('firstName')">
      <label class="inc-top">First Name</label>
      <input type="text" class="form-control reduce-width" formControlName="firstName">
      <div *ngIf="hasError('firstName')">
        <p class="err-msg" [innerText]="getErrorMsg('firstName')"></p>
      </div>
    </div>

    <!-- last name -->
    <div class="form-group" [ngClass]="isValid('lastName')">
      <label>Last Name</label>
      <input type="text" class="form-control reduce-width" formControlName="lastName">
      <div *ngIf="hasError('lastName')">
        <p class="err-msg" [innerText]="getErrorMsg('lastName')"></p>
      </div>
    </div>

    <!-- active -->
    <div class="form-group" *ngIf="isPortalAdmin">
      <label class="inc-top">Is Active</label>
      <div class="radio reduce-top">
        <label>
          <input type="radio" name="isActive" value="yes" formControlName="isActive">Yes
        </label>
      </div>
      <div class="radio">
        <label>
          <input type="radio" name="isActive" value="no" formControlName="isActive">No
        </label>
      </div>
    </div>
  </form>

  <!-- submit -->
  <button type="submit" class="btn btn-primary form-btn" [disabled]="!userForm.valid" (click)="onSubmit()">
    {{actionLabel}}
  </button>
  <button type="button" class="btn btn-primary form-btn" style="margin-left: 10px" (click)="cancelEdit()">
    Cancel</button>

  <!-- <button type="button" class="btn btn-primary form-btn" style="margin-left: 10px" (click)="debug()">
    Debug</button> -->

  <p-dialog header="Error" [(visible)]="showError" [modal]="true" [closeOnEscape]="false">
    <span>{{errorMessage}}</span>
    <p-footer>
      <button type="button" pButton (click)="closeMessage()" label="Close"></button>
    </p-footer>
  </p-dialog>
  <p-dialog header="User Account Request" [(visible)]="showAccReq" [modal]="true" [closeOnEscape]="false">
    <span>User account request have been submitted. The site administrator will contact you when the request have been
      approved.</span>
    <p-footer>
      <button type="button" pButton (click)="cancelEdit()" label="Close"></button>
    </p-footer>
  </p-dialog>
</div>